export default {
  layoutSelectors: ["#billing_phone"],
  inputIdentifier: "#billing_phone",
  countryIdentifier: "#billing_country",
  label: "billing checkout (phone)"
}
